exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/** 常用色值 **/\n/** 常用字体大小 **/\n.footer {\n  height: 100px;\n  padding: 40px 0;\n  text-align: center;\n  color: #d7d7d7;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js!./src/components/Footer/index.less
// module id = 722
// module chunks = 0